import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../../constants/actionTypes';
import LoadingIndicator from '../../../Common/LoadingIndicator/LoadingIndicator';

export class AllLocationsForm extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            allLocations: []
        };
    }

    async componentDidMount() {
        this.loadAllLocations();
    }

    loadAllLocations = async () => {
        try {
            this.setState({ isLoading: true });
            const response = await this.props.projectLocationActions.loadAllLocations(this.props.projectKey);
            if (response.type === types.LOAD_ALL_PROJECTLOCATION_LOCATIONS_SUCCESS) {
                this.setState({
                    allLocations: response.payload.locations
                });
                this.props.setSelectedLocations(response.payload.locations);
            } else if (response.type === types.LOAD_ALL_PROJECTLOCATION_LOCATIONS_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    render() {
        return (
            <LoadingIndicator isLoading={this.state.isLoading || this.props.isLoading}>
                <div className="all-locations-form">
                    <div className="row">
                        <div className="col">
                            <span className="has-float-label">
                                <select id="locationsList" className="form-control" multiple size="25" disabled>
                                    {
                                        this.state.allLocations.map(loc => <option key={loc.id} value={loc.id}>{loc.name}</option>)
                                    }
                                </select>
                                <label htmlFor="locationsList">Locations to receive tasks</label>
                            </span>
                        </div>
                    </div>
                </div>
            </LoadingIndicator>
        );
    }
}

AllLocationsForm.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    projectKey: PropTypes.string.isRequired,
    projectLocationActions: PropTypes.object.isRequired,
    setSelectedLocations: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired
}

export default AllLocationsForm;